import gql from 'graphql-tag';
import {
  FULL_CATALOG_INFORMATION_FIELDS,
  FULL_CATALOG_SUBSYSTEM_FIELDS,
  FULL_CATALOG_SYSTEM_FIELDS,
} from './catalog';

export const FULL_TEMPLATE_REPORT_FIELDS = gql`
  ${FULL_CATALOG_SYSTEM_FIELDS}
  ${FULL_CATALOG_SUBSYSTEM_FIELDS}
  ${FULL_CATALOG_INFORMATION_FIELDS}

  fragment FullTemplateReportFields on TemplateReportType {
    id
    baseTemplateReportId
    reInspectionTemplateReportId
    name
    description
    displayName
    inspectionType
    noDeficienciesAllowed
    noLimitationsAllowed
    templateSystems {
      id
      templateReportId
      catalogSystemId
      catalogSystem {
        ...FullCatalogSystemFields
      }
      displayIndex
      templateSubsystems {
        id
        templateSystemId
        catalogSubsystemId
        catalogSubsystem {
          ...FullCatalogSubsystemFields
        }
        displayIndex
        multiUseSubsystemName
        disableNotPresent
        includeOnReportIfNotPresent
        templateInformations {
          id
          templateSubsystemId
          catalogInformationId
          catalogInformation {
            ...FullCatalogInformationFields
          }
          displayIndex
        }
      }
    }
  }
`;
